module.exports = __webpack_public_path__ + "img/20190612_132334_021.a76abc7d.jpg";